var _rect, _rect2, _rect3, _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 150,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 150,
    width: 600,
    height: 150,
    fill: "#007a3d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 600,
    height: 100,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 200,150 0,300 z",
    fill: "#c4111b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 150,
    r: 40,
    fill: "#c4111b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 150,
    r: 40,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 289.26294,174.2204 17.05633,-12.19273 16.92296,12.37709 -6.32527,-19.98928 17.00081,-12.26999 -20.96556,-0.16131 -6.41591,-19.96036 -6.63215,19.88957 -20.96606,-0.0661 16.86669,12.45373 -6.54184,19.91946 z",
    fill: "#c4111b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEh);
export default __webpack_public_path__ + "static/media/eh.f5ee0a5e9a1dea8bc41a54ad5591eb5c.svg";
export { ForwardRef as ReactComponent };